// ContenuFiche/CreateMedia.jsx
import React from 'react';
import { Box, FormControl, TextField, Typography, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SpeechToTextButton from '../../components/SpeechToTextButton';

const CreateMedia = ({
  fecha,
  setFecha,
  titre,
  setTitre,
  videoUrl,
  setVideoUrl,
  detalles,
  setDetalles,
  markDirty,
  isSubmitting,
  handleCreateCard,
  backendUrl
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 3 }}>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <TextField
          label={t('playerCardCreator.mediaForm.date')}
          variant="outlined"
          type="date"
          value={fecha}
          onChange={(e) => {
            setFecha(e.target.value);
            markDirty();
          }}
          InputLabelProps={{
            shrink: true
          }}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <TextField
          label={t('playerCardCreator.mediaForm.title')}
          variant="outlined"
          value={titre}
          onChange={(e) => {
            setTitre(e.target.value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.mediaForm.titlePlaceholder')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <TextField
          label={t('playerCardCreator.mediaForm.videoUrl')}
          variant="outlined"
          value={videoUrl}
          onChange={(e) => {
            setVideoUrl(e.target.value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.mediaForm.videoUrlPlaceholder')}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <Typography variant="body1" gutterBottom>
          {t('playerCardCreator.mediaForm.details')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <SpeechToTextButton
            backendUrl={backendUrl}
            onTranscription={(transcript) => {
              setDetalles((prev) => prev + '\n' + transcript);
              markDirty();
            }}
          />
        </Box>
        <ReactQuill
          theme="snow"
          value={detalles}
          onChange={(value) => {
            setDetalles(value);
            markDirty();
          }}
          placeholder={t('playerCardCreator.mediaForm.detailsPlaceholder')}
        />
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        onClick={handleCreateCard}
        sx={{ mt: 3 }}
        fullWidth
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
            {t('playerCardCreator.mediaForm.saving')}
          </>
        ) : (
          t('playerCardCreator.mediaForm.saveMedia')
        )}
      </Button>
    </Box>
  );
};

export default CreateMedia;
